import styled from 'styled-components';
import ModalAntd from '@deprecated-ui/common/Modal';
import BaseConfirmationModal from 'global/Modal/BaseConfirmationModal';
import Image from 'global/Image';

export const EipoPageContainer = styled.div`
  max-width: 1400px;
  margin: auto;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 2px;
  border: 1px solid #ededed;
`;

export const Modal = styled(ModalAntd)`
  .ant-modal-body {
    border-radius: 12px;
  }

  .ant-modal-close {
    display: none;
    visibility: hidden;
    opacity: 0;
  }
`;

export const ModalSuccess = styled(BaseConfirmationModal)`
  & .ant-modal-body {
    padding: 18px 0 8px;
  }

  & .base-modal-header {
    margin-bottom: 18px;
  }

  & .button-row {
    padding: 20px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const Illustration = styled(Image)`
  width: 160px;
  height: auto;

  margin-bottom: 24px;
`;

export const InfoText = styled.p`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 16px;
  white-space: pre-line;
  text-align: center;
`;

export default {
  EipoPageContainer,
  Modal,
  ModalSuccess,
  InfoWrapper,
  Illustration,
  InfoText,
};
